import styled from 'styled-components';

export const StyledActivityTable = styled.div`
  position: relative;
  padding-top: 1rem;
  & .withStickyHeader {
    height: 5rem;
  }
`;
